"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testAxeRun = void 0;
exports.renderWith = renderWith;
exports.getComponentWith = getComponentWith;
var jsx_runtime_1 = require("react/jsx-runtime");
var router_context_shared_runtime_1 = require("next/dist/shared/lib/router-context.shared-runtime");
var dp_axe_core_lib_1 = require("@greatmindsorg/dp-axe-core-lib");
var react_1 = require("@testing-library/react");
var baseTheme_1 = __importDefault(require("@greatmindsorg/atomic-ui-lib-lts/dist/themes/baseTheme"));
var Auth_1 = require("../../modules/Auth");
var AppContext_1 = require("../../modules/AppContext");
var context_1 = require("../../api/context");
var AlertManager_1 = require("../../modules/Common/Alert/AlertManager");
var styled_components_1 = require("styled-components");
var mock_helper_1 = require("./mock.helper");
var __1 = require("..");
var models_mock_1 = require("../../api/models/mocks/models.mock");
var AtomicAlertManager_1 = require("../../modules/Common/AtomicAlert/AtomicAlertManager");
var createMockRouter = function (router) {
    return __assign({ basePath: '', pathname: '/', route: '/', query: {}, asPath: '/', back: jest.fn(), beforePopState: jest.fn(), prefetch: jest.fn(), push: jest.fn(), reload: jest.fn(), replace: jest.fn(), events: {
            on: jest.fn(),
            off: jest.fn(),
            emit: jest.fn(),
        }, isFallback: false, isLocaleDomain: false, isReady: true, defaultLocale: 'en', domainLocales: [], isPreview: false }, router);
};
function renderWith(node_1) {
    return __awaiter(this, arguments, void 0, function (node, options) {
        var mergedOptions;
        if (options === void 0) { options = {}; }
        return __generator(this, function (_a) {
            mergedOptions = {
                authContextState: options.authContextState ||
                    new Auth_1.AuthContextState({
                        user: (0, models_mock_1.mockUser)(),
                        schoolYear: (0, models_mock_1.mockSchoolYear)({ id: 'active-school-year', name: '2020-2021' }),
                    }),
                serviceContextState: (0, __1.mockServices)(options.serviceContextState),
                appContextState: options.appContextState || new AppContext_1.AppContextState({ classes: [(0, models_mock_1.mockClass)()] }),
            };
            return [2 /*return*/, (0, react_1.render)(getComponentWith(node, mergedOptions))];
        });
    });
}
function getComponentWith(node, options) {
    var router = createMockRouter(__assign({}, options.nextRouterOptions));
    return ((0, jsx_runtime_1.jsx)(router_context_shared_runtime_1.RouterContext.Provider, { value: router, children: (0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: options.theme || (0, mock_helper_1.mockTheme)(), children: (0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: baseTheme_1.default, children: (0, jsx_runtime_1.jsx)(AlertManager_1.AlertManager, { children: (0, jsx_runtime_1.jsx)(AtomicAlertManager_1.AtomicAlertManager, { children: (0, jsx_runtime_1.jsx)(Auth_1.AuthContext.Provider, { value: options.authContextState, children: (0, jsx_runtime_1.jsx)(context_1.ServiceContext.Provider, { value: options.serviceContextState, children: (0, jsx_runtime_1.jsx)(AppContext_1.AppStateProvider, { initialValue: options.appContextState, children: node }) }) }) }) }) }) }) }));
}
var testAxeRun = function (html, axeConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = expect;
                return [4 /*yield*/, (0, dp_axe_core_lib_1.axeRun)(html, axeConfig)];
            case 1:
                _a.apply(void 0, [_b.sent()]).toBeNull();
                return [2 /*return*/];
        }
    });
}); };
exports.testAxeRun = testAxeRun;
